@use '@/scss/underscore' as _;

.oidcConfigPreview {
  margin-top: _.unit(3);
}
